import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageComponent from '../components/PageComponent';

export default class Page401 extends PageComponent {

  static PageInfo = { 
    show: false,
    
    path: "/notfound",
    name: "menu.notFound",
    icon: "question-circle"
  }


  renderPage() {
    return <div>
      Error 401:
   <br />
   You don't have access to this resource!</div>;
  }

  render() {
    return (
      global.token != null ?
        <Container context={this.constructor} props={this.data}>
          {this.renderPage()}
        </Container>
        : this.renderPage()
    );
  }
}

